<template>
    <div>
        <el-dialog title="创建任务" :visible="true" :before-close="handleClose">
            <el-form :model="form" ref="form" :rules="rules">

                <el-form-item label="任务类型" prop="type" :label-width="formLabelWidth">
                    <el-radio-group v-model="form.type">
                        <el-radio v-for="(option, key) in typeOptions" :label="key" :key="key"> {{option}}</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="任务主题" prop="subject" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="form.subject" auto-complete="off"></el-input>
                </el-form-item>

                <el-form-item label="客户" prop="customer_id" :label-width="formLabelWidth">
                    <el-input :disabled="true" placeholder="请选择客户" v-model="form.customer_name" auto-complete="off">
                        <el-button slot="append" icon="el-icon-search" @click="showCustomerFilter = true">选择客户
                        </el-button>
                    </el-input>
                </el-form-item>

                <el-form-item label="备注" prop="memo" :label-width="formLabelWidth">
                    <el-input type="textarea" :rows="5" v-model="form.memo" auto-complete="off"></el-input>
                </el-form-item>

                <el-form-item label="执行人" prop="executor_id" :label-width="formLabelWidth">
                    <user-select v-model="form.executor_id" isMultiple="false" @change="handleUserSelect"></user-select>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button :loading="loading" type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
        <customer-filter v-if="showCustomerFilter" :show-dialog="showCustomerFilter" @filterCallback="watchFilterCallback" @watchModalClose="watchModalClose"></customer-filter>
    </div>


</template>

<script>
    import TaskService from "~/services/task";
    import UserSelect from "~/widgets/UserSelect.vue";
    import CustomerFilter from "~/widgets/CustomerFilter.vue";

    export default {
        name: "TaskForm",
        components: {
            CustomerFilter,
            UserSelect
        },
        props: {
            taskModel: {},
            // showDialog: {
            //     type: Boolean,
            //     required: true
            // },
            scenario: "create"
        },
        created: function () {
            this.typeOptions = TaskService.getTypes();
            if (this.taskModel) {
                this.form = this.taskModel;
            }
        },
        data() {
            return {
                // 是否显示客户过滤器
                showCustomerFilter: false,
                typeOptions: {},
                form: null,
                formLabelWidth: "120px",
                isShow: false,
                loading: false,
                rules: {
                    subject: [
                        {
                            required: true,
                            message: "请输入任务主题"
                        },
                        {
                            type: "string",
                            max: 255,
                            message: "超度不能超过255个字符"
                        }
                    ],
                    type: [
                        {
                            required: true,
                            message: "请正确选择类型"
                        }
                    ],
                    customer_id: [
                        {
                            required: true,
                            message: "请指定客户"
                        }
                    ],
                    executor_id: [
                        {
                            required: true,
                            message: "请指定任务执行人"
                        }
                    ]
                }
            };
        },
        watch: {
            // 监听属性 showDialog
            // showDialog: function (val, oldValue) {
            //     this.isShow = val;
            // }
        },
        methods: {
            // 关闭窗口
            handleClose(done) {
                this.$confirm("陛下你还没有保存内容，确认要关闭窗口？")
                    .then(_ => {
                        this.loading = false;
                        this.$refs["form"].resetFields();
                        this.close();
                        done();
                    })
                    .catch(_ => {
                    });
            },

            // 处理用户选择
            handleUserSelect(object) {
                this.form.executor_id = object.label;
            },

            // 关闭当前窗口
            close() {
                this.isShow = false;
                // 往上层组件传递更改后的状态
                this.$emit("changeShow", this.isShow);
            },

            // 提交表单
            submitForm() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        TaskService.create(this.form)
                            .then(res => {
                                if (res && res.data) {
                                    this.loading = false;
                                    this.$message({
                                        type: "success",
                                        message: "创建成功！"
                                    });
                                    this.close();
                                    this.$refs["form"].resetFields();
                                    this.$emit("saveCallback", res.data)
                                }
                            })
                            .catch(err => {
                                this.loading = false;
                                console.error(err);
                            });
                    }
                });
            },

            // 监听客户过滤器组件对话窗口的关闭事件回调
            // 当窗口关闭当前组件需要将设置窗口显示的开关设为关闭
            watchModalClose (isShow) {
                this.showCustomerFilter = isShow;
            },

            // 监听客户过滤器组件的回调
            watchFilterCallback(customer) {
                // console.log(customer);
                this.form.customer_id = customer.id;
                this.form.customer_name = customer.name;
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/tasks/form.vue